
/* injects from baggage-loader */

'use strict';

export default class DialogPuzzleController {
    constructor($log) {
        'ngInject';
        this.$log = $log;
    }

    ok(){
      this.modalInstance.close(true);
    }

    cancel(){
      this.modalInstance.dismiss('cancel');
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/puzzle/puzzle.controller.js